import { useState, useEffect } from 'react';
import { useNavigate ,useLocation } from 'react-router-dom';
import { verifyOtp , resendOtp, verifyForgotEmail , forgotPassword } from '../../../services/authService';


const useOTPVerification = ({type = 'email' , triggerResend}) => {
  const navigate = useNavigate();
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [heading, setHeading] = useState('');
  const [message, setMessage] = useState('');
  const location = useLocation();
  const state = location.state;

  useEffect(() => {
    if (type === 'mobile') {
      setHeading('Verify your phone number');
      setMessage('We’ve sent an OTP to your mobile number.');
      triggerResend(type);
    } else {
      setHeading('Verify your email');
      setMessage('We’ve sent an OTP to your email address.');
    }
  }, [type]);

  const handleChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) setOtp(value);
  };

  const handleSubmit = async (fullOtp) => {
    setLoading(true);
    try {
      let response;
      if (type === 'email') {
        response = await verifyOtp({   otp: fullOtp, type: 'email' });
        const { success, data, message } = response;
        if (response.success) {
          const {email_verify, email } = data;
          localStorage.setItem('email_verify', email_verify);
          navigate('/dashboard')
          setLoading(false);
          return;
        }
      }

      // if (type === 'mobile') {
      //   response = await verifyOtp({ otp: fullOtp, type: 'phone' });
      //   const { success, data, message } = response;
      //   if (response.success) {
      //     const { phone_verify, email } = data;
      //     localStorage.setItem('phone_verify', phone_verify);
      //     navigate('/dashboard')
      //     setLoading(false);
      //     return;
      //   }
      // }

      if (type === 'forgotOtp') {
        response = await verifyForgotEmail({user :{ otp: fullOtp, email: state?.email }});
        if (response.success) {
          localStorage.setItem('reset_password_token', response?.data?.reset_password_token);
          navigate('/reset-password', {
            state: {
              successMessage: 'Password Forgot has been successfully.',
              label: 'Reset Password',
            },
          });
          setLoading(false);
          return;
        }
      }
    } catch (err) {
      console.error('OTP verification failed:', err);
      setLoading(false);
    }
  };

  const handleResend = async (type) => {
    try {
      let response;
      if (type === "forgotOtp") {
        response = await forgotPassword({user :{ email: state?.email }});
      } else {
        response = await resendOtp({ type });
      }

      if (response.success) {
        setTimeout(() => {
          setLoading(false);
        }, 3000);
      } else {
        setLoading(false);
      }
    } catch (err) {
      console.error('Resend/forgot OTP failed:', err);
      setLoading(false);
    }
  };


  return {
    otp,
    heading,
    message,
    loading,
    handleChange,
    handleSubmit,
    handleResend,
  };
};

export default useOTPVerification;
